import React from 'react'
import { Box, Typography } from '@mui/material'
import AdBanner from './AdBanner'
import NativeAd from './NativeAd'

const AdPlacement = ({ 
  type = 'banner', // 'banner', 'native', 'interstitial'
  position = 'content', // 'header', 'sidebar', 'content', 'footer'
  size = 'medium', // 'small', 'medium', 'large', 'responsive'
  userRole = 'student', // 'student', 'teacher' - öğretmenlere daha az reklam
  pageType = 'general' // 'quiz', 'game', 'reading', 'general'
}) => {
  
  // Öğretmenlere daha az reklam göster
  if (userRole === 'teacher' && Math.random() < 0.7) {
    return null
  }

  // Sayfa türüne göre reklam konfigürasyonu
  const getAdConfig = () => {
    const configs = {
      quiz: {
        allowInterstitial: true,
        preferredTypes: ['course', 'app'],
        timing: 'after_completion'
      },
      game: {
        allowInterstitial: true,
        preferredTypes: ['app', 'book'],
        timing: 'between_levels'
      },
      reading: {
        allowInterstitial: false,
        preferredTypes: ['book', 'course'],
        timing: 'content_break'
      },
      general: {
        allowInterstitial: false,
        preferredTypes: ['course', 'book', 'app'],
        timing: 'any'
      }
    }
    return configs[pageType] || configs.general
  }

  const config = getAdConfig()

  // Boyut konfigürasyonları
  const sizeConfigs = {
    small: { width: '300px', height: '100px' },
    medium: { width: '728px', height: '250px' },
    large: { width: '970px', height: '300px' },
    responsive: { width: '100%', height: 'auto' }
  }

  const currentSize = sizeConfigs[size] || sizeConfigs.medium

  // Banner Reklam
  if (type === 'banner') {
    return (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center',
        my: position === 'content' ? 3 : 1
      }}>
        <AdBanner 
          slot="XXXXXXXX" // AdSense slot ID
          width={currentSize.width}
          height={currentSize.height}
          responsive={size === 'responsive'}
        />
      </Box>
    )
  }

  // Native Reklam
  if (type === 'native') {
    const randomType = config.preferredTypes[Math.floor(Math.random() * config.preferredTypes.length)]
    return (
      <Box sx={{ 
        maxWidth: position === 'sidebar' ? '300px' : '100%',
        mx: position === 'sidebar' ? 0 : 'auto'
      }}>
        <NativeAd type={randomType} position={position} />
      </Box>
    )
  }

  // Interstitial Reklam Placeholder
  if (type === 'interstitial' && config.allowInterstitial) {
    return (
      <Box sx={{ 
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        bgcolor: 'rgba(0, 0, 0, 0.8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999
      }}>
        <Box sx={{ 
          bgcolor: 'white',
          p: 3,
          borderRadius: 2,
          maxWidth: '90vw',
          maxHeight: '90vh'
        }}>
          <Typography variant="h6" gutterBottom>
            🎯 Interstitial Reklam Alanı
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Bu alan tam ekran reklamlar için kullanılacak
          </Typography>
        </Box>
      </Box>
    )
  }

  return null
}

export default AdPlacement
